import { QueryClient, QueryClientProvider } from 'react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { useErrorBoundary: false, refetchOnWindowFocus: false, retry: 0 },
    mutations: { useErrorBoundary: false, retry: 0 },
  },
});

export { QueryClientProvider };
